import { PrimeReactStylesFunctionType } from '../types';
import { classNames } from 'primereact/utils';

export const RadioButtonTailwindThemes = {
  radiobutton: {
    root: {
      className: classNames('inline-flex relative select-none align-bottom items-center justify-center', 'size-[12px]'),
    },
    input: {
      className: classNames(
        'peer',
        'absolute appearance-none top-0 left-0 size-full p-0 m-0 opacity-0 z-10 outline-none cursor-pointer',
      ),
    },
    box: ({ props, context }: PrimeReactStylesFunctionType) => {
      const checked = context?.checked ?? props.checked;

      return {
        className: classNames(
          'relative inline-flex items-center justify-center size-[11px] rounded-full transition-colors duration-200',
          !checked && 'border border-fletchers-gray-110 bg-transparent',
          checked &&
            [
              'bg-fletchers-green-800',
              'before:content-[""] before:absolute before:inset-[1px] before:rounded-full before:bg-white',
              'after:content-[""] after:absolute after:inset-[2px] after:rounded-full after:bg-fletchers-green-800',
            ].join(' '),
          props.className,
        ),
      };
    },
    icon: {
      className: classNames('size-0'),
    },
  },
};
